var React = require('react');

function UiCheckmark2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Checkmark 2"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M95.68,126.9c-13-12-34-34-48-48-14-13-23-2-40,16-19,19,0,29,27,56l49,49c18,16,33-8,57-31l98-99c31-30,38-30,13-54-22-23-21-23-56,13C179.68,43.9,100.68,123.9,95.68,126.9Z"})))]);
}

UiCheckmark2.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 266.85 205.09","style":{"enableBackground":"new 0 0 266.85 205.09"},"xmlSpace":"preserve"};

module.exports = UiCheckmark2;

UiCheckmark2.default = UiCheckmark2;
